import React from "react";
import { ContextSelectedOptions } from "../../../../../context-selector/src/ContextDropdown";
import { AccuracyChart } from "../../../components/charts/accuracy/AccuracyChart";
import { TemporalContext } from "../../../components/temporalContextSelector/data/temporalContextOptions";
import { ReviewDataResponse } from "../hooks/useFetchReviewData";
import { useFetchTrendLine } from "../hooks/useFetchTrendLine";

interface AccuracyTabProps {
  appliedFilters: {
    contextOptions: ContextSelectedOptions;
    temporalOptions: TemporalContext;
  };
  hasUserApplied: boolean;
  reviewData: ReviewDataResponse;
  isReviewDataLoading: boolean;
}

export const AccuracyTab = React.memo(function AccuracyTab({
  appliedFilters,
  hasUserApplied,
  reviewData,
  isReviewDataLoading
}: AccuracyTabProps) {
  const { data: trendLineData, isFetching } = useFetchTrendLine(
    appliedFilters.contextOptions,
    appliedFilters.temporalOptions,
    hasUserApplied
  );

  return (
    <AccuracyChart
      inSeasonReviewData={reviewData}
      trendLineData={trendLineData ?? []}
      isLoading={isFetching || isReviewDataLoading}
    />
  );
});
